/**
 * World-pose entity for a dropped weapon or grenade.
 *
 * This is now a thin wrapper around the shared `weaponBuilder` —
 * dropped items render with IDENTICAL geometry + materials to the
 * in-hand view-model. Both the LocalWeaponView and this module route
 * through `buildWeaponModel`, so a dropped AK is literally the same
 * mesh as the one in your hands.
 *
 * Coordinate handoff: the builder constructs the model in the original
 * "held / camera-relative" pose. The GroundItemRenderer wraps the
 * returned entity in a holder that lays it flat (Z-axis tilt) and
 * applies a world yaw so each drop can have its own orientation.
 */

import * as pc from "playcanvas";
import { buildWeaponModel } from "./weaponBuilder";

/**
 * Build the world-pose entity for a dropped weapon or grenade.
 * Caller is responsible for positioning + rotating + adding to the scene.
 *
 * Wrapped in try/catch so any future builder regression on one weapon
 * can't break the whole GroundItemRenderer snapshot loop (the symptom
 * we hit before: throwing inside the per-item create silently dropped
 * every subsequent item from the broadcast).
 */
export function buildWeaponWorldModel(_app: pc.AppBase, weaponId: string): pc.Entity {
  const root = new pc.Entity(`ground-${weaponId}`);
  try {
    buildWeaponModel(root, weaponId);
  } catch (err) {
    console.warn(`[ground-item] failed to build model for ${weaponId}:`, err);
  }
  return root;
}
